import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import tippy, { Instance, Props } from 'tippy.js';

@Directive({
  selector: '[appTippy]',
  standalone: true,
})
export class TippyDirective implements OnInit, OnChanges, OnDestroy {
  @Input('appTippy') content: string | null = null;
  @Input() tippyPlacement: Props['placement'] = 'top';
  @Input() tippyTheme: Props['theme'] = 'light-border';
  @Input() tippyTrigger: Props['trigger'] = 'mouseenter focus';

  private instance?: Instance;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.createInstance();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'] && this.instance) {
      this.instance.setContent(this.content ?? '');
    }

    if (changes['tippyPlacement'] || changes['tippyTheme'] || changes['tippyTrigger']) {
      this.destroyInstance();
      this.createInstance();
    }
  }

  ngOnDestroy(): void {
    this.destroyInstance();
  }

  private createInstance(): void {
    this.instance = tippy(this.elementRef.nativeElement, {
      content: this.content ?? '',
      placement: this.tippyPlacement,
      theme: this.tippyTheme,
      trigger: this.tippyTrigger,
      allowHTML: false,
      maxWidth: 360,
    });
  }

  private destroyInstance(): void {
    if (this.instance) {
      this.instance.destroy();
      this.instance = undefined;
    }
  }
}
